import createHandWritingDirective from '../utils/hand-writing-directive-creator'
import JapaneseHandWritingLink from '../links/japanese'
import JapaneseHandWritingController from '../controllers/japanese'

/**
 * iinkJS日本語入力用ディレクティブ
 * 
 * [依存関係]
 * JapaneseHandWritingLink,
 * JapaneseHandWritingController
 */
export default () => {
  angular
  .module('JapaneseHandWritingModule')
  .directive('iinkJapaneseWeb', [
    createHandWritingDirective({
      linkClass: JapaneseHandWritingLink,
      controller: JapaneseHandWritingController
    })
  ])
}